import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import Config from '../../Config';
import ProviderManager from '../../provider/providerManager';

export const getGlobalConfig = createAsyncThunk('initApp/getGlobalConfig', async (data, thunkAPI) => {
  try {
    const res = await ProviderManager.getProviderData('GlobalConfig', []);
    return res.Body;
  } catch (e) {
    //TODO: handle error
    throw e;
  }
});

const initAppSlice = createSlice({
  name: 'initApp',
  initialState: {
    isGlobalConfigFinish: false
  },
  reducers: {},
  extraReducers: {
    [getGlobalConfig.fulfilled]: (state, action) => {
      state = action.payload;
      state.isGlobalConfigFinish = true;
      return action.payload;
    },
    [getGlobalConfig.rejected]: (state, action) => {
      state.isGlobalConfigFinish = true;
      return action.payload;
    },
  },
});

export const { } = initAppSlice.actions;

export default initAppSlice.reducer;
